import React from 'react';
import { FormTextInput } from 'components/ui';
import './textarea.scss';

const FormTextarea = (props) => {
  return <FormTextInput {...props} type="textarea" />;
};

FormTextarea.propTypes = {
  ...FormTextInput.propTypes,
};

export default FormTextarea;
